import { useTranslation } from "react-i18next";
import Popup, {
  PopupActions,
  PopupButton,
  PopupContent,
  PopupHeading,
} from "../../../components/Common/Popup";
import React from "react";

const TermsOfPurchaseDialog = (props) => {
  const { t } = useTranslation();
  return (
    <Popup onClose={props.onClose}>
      <PopupHeading>{t("Terms of purchase")}</PopupHeading>
      <PopupContent>
        <div
          dangerouslySetInnerHTML={{
            __html: props.termsOfPurchase.replace(/\n/g, "<br/>"),
          }}
        />
      </PopupContent>

      <PopupActions>
        <PopupButton fullWidth onClick={props.onClose}>
          {t("Close")}
        </PopupButton>
      </PopupActions>
    </Popup>
  );
};

export default TermsOfPurchaseDialog;
